import { AutocompleteInput, ReferenceInput, required } from 'react-admin';

import { GetInstrumentsQuery, GetInstrumentsResponse } from '@Common/types/bo/instruments';

import { inputDisabledProps, RaSort } from '@sh4res/bo-common/utils';

const defaultInstrumentsSort: RaSort<GetInstrumentsQuery> = { field: 'id', order: 'ASC' };

export type InstrumentsAutocompleteReferenceInputProps = {
  source: string;
  filters?: GetInstrumentsQuery['filter'];
  isRequired?: boolean;
  label?: string;
  shouldUnregister?: boolean;
  disabled?: boolean;
  testId?: string;
};

export const InstrumentsAutocompleteReferenceInput = (
  props: InstrumentsAutocompleteReferenceInputProps,
) => {
  const { source, filters, isRequired, label, shouldUnregister, disabled, testId } = props;

  return (
    <ReferenceInput
      shouldUnregister={shouldUnregister}
      source={source}
      reference="instruments"
      perPage={15}
      sort={defaultInstrumentsSort}
      data-testid={testId ? `${testId}_ReferenceInput` : undefined}
      filter={filters}
      enableGetChoices={disabled ? () => false : undefined}>
      <AutocompleteInput
        optionText={({ name, symbol, id }: GetInstrumentsResponse[number]) =>
          `${name || symbol} - #${id}`
        }
        filterToQuery={(searchText: string) => ({
          ...filters,
          query: searchText,
        })}
        label={label}
        isRequired={isRequired}
        validate={isRequired ? [required()] : undefined}
        {...inputDisabledProps(
          disabled ?? false,
          disabled
            ? {
                backgroundColor: 'transparent',
                opacity: 1,
                '& .MuiFilledInput-root': {
                  backgroundColor: (theme) => theme.palette.action.disabledBackground,
                  opacity: 0.8,
                },
              }
            : undefined,
        )}
        data-testid={testId ? `${testId}_AutocompleteInput` : undefined}
      />
    </ReferenceInput>
  );
};
